import {
  Block,
  FlexGridItem,
  HeadingSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

import mezoComputerImage from "#/assets/mezo-computer.png"
import { DASHBOARD_HEADER_HEIGHT } from "#/shared/constants"
import { DashboardHeaderLogo, DashboardHeaderWrapper } from "#/ui/Layout"

export default function MobileView() {
  const [css, theme] = useStyletron()

  return (
    <Block
      className={css({
        height: "100vh",
        overflow: "hidden",
      })}
    >
      <DashboardHeaderWrapper items={1}>
        <FlexGridItem>
          <DashboardHeaderLogo />
        </FlexGridItem>
      </DashboardHeaderWrapper>
      <Block
        className={css({
          padding: `${theme.sizing.scale900} ${theme.sizing.scale1200} 0`,
          height: `calc(100% - ${DASHBOARD_HEADER_HEIGHT}px)`,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
        })}
      >
        <Block width="100%" marginBottom={theme.sizing.scale1000}>
          <Block maxWidth="279px">
            <HeadingSmall>
              We&apos;re still working on making Mezo fit into this space.
            </HeadingSmall>
            <br />
            <HeadingSmall>Please use a larger window to continue.</HeadingSmall>
          </Block>
        </Block>
        <Block as="img" src={mezoComputerImage} />
      </Block>
    </Block>
  )
}
